import React, { useEffect, useState } from "react";
import {
  API_BASE_URL,
  DELETE_MASTER_SPECIALITY,
  directToken,
  LIST_OF_MASTER_SPECIALITY,
} from "../services/end_points";
import { _delete, _get } from "../services/service_api";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Col, Grid, Input, Modal, Row, Table } from "antd";
import DefaultLayout from "../../Defaultlayout/DefaultLayout";
import AddSpeciality from "./AddSpeciality";
import EditSpeciality from "./EditSpeciality";
const { useBreakpoint } = Grid;
const SpecialityList = () => {
  // const { column, rows } = roledata({ handleRole });
  const [alert, setAlert] = useState(null);
  const [city, setCity] = useState([]);
  const [open, setOpen] = useState(false);
  const [formdata, setFormData] = useState([]);
  const [editing, setEditing] = useState(false);
  const [filteredCities, setFilteredCities] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const pageSize = 8;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await _get(
        `${API_BASE_URL}${LIST_OF_MASTER_SPECIALITY}`,
        directToken
      );
      if (response && response.data && response.data.list) {
        setCity(response.data.list);
        setFilteredCities(response.data.list);
      } else {
        console.error("Response data is not as expected:", response.data);
      }
    } catch (error) {
      console.error(
        "Error fetching locations:",
        error.response?.data || error.message || error
      );
    }
  };
  const showModal = () => setIsModalVisible(true);
  const closeModal = () => {
    setIsModalVisible(false);
    setIsEditing(false);
  };

  const handleEdit = (data) => {
    setFormData(data);
    setOpen(true);
    setEditing(true);
  };

  const handleDelete = async (data) => {
    try {
      const response = await _delete(
        `${API_BASE_URL}${DELETE_MASTER_SPECIALITY}${data}`
      );
      fetchData();
      setAlert({
        type: "success", // Set this to 'error' if needed
        message: response.data.message || "Appt Deleted!",
      });
      const totalItems = city.length - 1; // Account for the deleted item
      const totalPages = Math.ceil(totalItems / pageSize);
      if (currentPage > totalPages && totalPages > 0) {
        setCurrentPage(totalPages); // Go to the last page if current page exceeds total pages
      } else if (totalPages === 0) {
        setCurrentPage(1); // If no items left, reset to page 1
      }
    } catch (error) {
      console.error("Error deleting Location:", error);
    }
  };

  const handleAddLocation = () => {
    setOpen(true);
  };
  const handleEditforopup = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
    setIsEditing(true);
  };
  const handleClose = () => {
    setOpen(false);
    setEditing(false);
    fetchData();
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();

    if (value === "") {
      setFilteredCities(city);
    } else {
      const filtered = city.filter(
        (cityItem) =>
          cityItem.specialities_names &&
          cityItem.specialities_names.toLowerCase().includes(value)
      );

      setFilteredCities(filtered);
    }

    setCurrentPage(1); // Reset to the first page when searching
  };

  const paginatedData = filteredCities.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const columns = [
    {
      title: "S.No",
      dataIndex: "serialNumber",
      key: "serialNumber",
      render: (_, __, index) => index + 1 + (currentPage - 1) * pageSize,
    },
    {
      title: "Speciality",
      dataIndex: "specialities_names",
      key: "specialities_names",
    },
    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      render: (_, record) => (
        <div>
          <Button
            size="small"
            style={{
              fontSize: "12px",

              border: "1px solid #0899f9",
              color: "#0899f9",
            }}
            onClick={() => handleEditforopup(record)}
          >
            <EditOutlined />
          </Button>

          {/* {rows[0]?.id === 1 && ( */}
          <Button
            size="small"
            style={{
              marginLeft: "5px",
              fontSize: "12px",

              border: "1px solid #941717",
              color: "#941717",
            }}
            onClick={() => handleDelete(record.id)}
          >
            <DeleteOutlined />
          </Button>
          {/* // )} */}
        </div>
      ),
    },
  ];
  const screens = useBreakpoint();
  let modalWidth;
  if (screens.xl) {
    modalWidth = 350;
  } else if (screens.lg) {
    modalWidth = 250;
  } else if (screens.md) {
    modalWidth = 200;
  } else if (screens.sm) {
    modalWidth = 400;
  } else {
    modalWidth = 300;
  }
  const updateUserList = (newUser) => {
    setSelectedRecord((prevUser) => {
      const validPrevUser = Array.isArray(prevUser) ? prevUser : [];
      const index = validPrevUser.findIndex(
        (user) => user.userid === newUser.userid
      );
      if (index === -1) {
        // Add new user
        return [...validPrevUser, newUser];
      } else {
        // Update existing user
        const updatedUsers = [...validPrevUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });

    setFilteredCities((prevFilteredUser) => {
      const validPrevFilteredUser = Array.isArray(prevFilteredUser)
        ? prevFilteredUser
        : [];
      const index = validPrevFilteredUser.findIndex(
        (user) => user.userid === newUser.userid
      );
      if (index === -1) {
        // Add new user
        return [...validPrevFilteredUser, newUser];
      } else {
        // Update existing user
        const updatedUsers = [...validPrevFilteredUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });

    fetchData();
  };

  return (
    <DefaultLayout>
      <Card style={{ width: "100%", minHeight: "600px", height: "100%" }}>
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <h2>Speciality List</h2>
          </Col>
          <Col xs={24} sm={24} md={10} lg={10} xl={10}>
            <Input
              style={{ width: "100%", height: "45px" }}
              placeholder="Search Speciality"
              onChange={handleSearch}
            />
          </Col>
          <Col
            xs={24}
            sm={24}
            md={6}
            lg={6}
            xl={6}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              style={{
                // backgroundColor: "#feccdc",
                backgroundColor: "#6499f1",
                color: "white",
                fontSize: "14px",
                fontWeight: "600",
                borderRadius: "10px",
                width: "100%",
                height: "48px",
                maxWidth: "200px",
              }}
              onClick={showModal}
            >
              Create Speciality
            </Button>
          </Col>
        </Row>

        <Row>
          <Col xs={24} sm={24} md={22} lg={20} xl={24}>
            <div style={{ width: "100%", overflowX: "auto" }}>
              <Table
                columns={columns}
                dataSource={paginatedData}
                rowKey="id"
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  total: filteredCities.length,
                  onChange: handlePageChange,
                  showSizeChanger: false,
                }}
                scroll={{ x: true }}
              />
            </div>
          </Col>
        </Row>
        <Modal
          title={isEditing ? "Edit Speciality" : "Create Speciality"}
          // title={"Create Speciality"}
          visible={isModalVisible}
          onCancel={closeModal}
          footer={null}
          width={modalWidth}
        >
          {isEditing ? (
            <EditSpeciality data={selectedRecord} />
          ) : (
            <AddSpeciality updateUserList={updateUserList} />
          )}
        </Modal>
      </Card>
    </DefaultLayout>
  );
};
export default SpecialityList;
